import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import { FaArrowLeft, FaSpinner } from 'react-icons/fa';

import ReactQuill from 'react-quill'; // Importing ReactQuill
import 'react-quill/dist/quill.snow.css';
import Breadcrumb from '../Breadcrumb'; 

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BlogForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [initialLoading, setInitialLoading] = useState(!!id);
  
  // State to manage form fields
  const [title, setTitle] = useState('');
  const [content, setContent] = useState(''); // For rich text content
  const [featuredImage, setFeaturedImage] = useState(null);
  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
    
    const routes = [
        { name: 'Home',  path: '/dashboard' },
        { name: 'Blogs', path: '/blogs' },
        { name:'Create', path:'/blogs/create'}
    ];

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleFileChange = (e, setImage) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Prepare form data to send, including images
    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content); 
    if (featuredImage) formData.append('featured_image', featuredImage);
    if (thumbnailImage) formData.append('thumbnail_image', thumbnailImage);

    try {
      if (id) {
        // Update an existing blog
        await axios.put(`${API_BASE_URL}/blogs/${id}`, formData);
      } else {
        // Create a new blog
        await axios.post(`${API_BASE_URL}/blogs`, formData);
      }
      navigate('/blogs');
    } catch (error) {
      console.error('Error submitting blog:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (initialLoading) {
    return (
      <div className="d-flex">
        <Sidebar />
        <div className='container my-5 flex-grow-1'>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-container">
      {/* <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} /> */}
      <div className={`leads-content ${isSidebarOpen ? 'expanded' : 'collapsed'}`}>
      
        <div className='container my-5 flex-grow-1'>
        <div className='d-flex'>
        <Breadcrumb routes={routes}/>
        <button className="btn ls-btn  main-btn ms-auto" style={{width:'120px',height:'50px'}} onClick={() => navigate('/blogs')}>
          <FaArrowLeft /> Back
        </button>
        </div>
        <div className="card-header text-dark">
              <h3 className="mb-0">{id ? 'Update Blog' : 'Create Blog'}</h3>
            </div>
          <div className="card white-box-shadow mt-4">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label htmlFor="title">Blog Title:</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Enter blog title" 
                    id="title" 
                    value={title} 
                    onChange={(e) => setTitle(e.target.value)} 
                    required 
                  />
                </div>
               <div className="form-group mb-3">
                  <label htmlFor="content">Blog Content:</label>
                  <ReactQuill 
                    value={content} 
                    onChange={setContent} 
                    placeholder="Write your blog content here..." 
                    theme="snow" 
                    modules={{
                      toolbar: [
                           [{ header: [1, 2, 3, 4, 5, 6, false] }],
                           ["bold", "italic", "underline", "strike", "blockquote"],
                           [{ size: [] }],
                           [{ font: [] }],
                           [{ align: ["right", "center", "justify"] }],
                           [{ list: "ordered" }, { list: "bullet" }],
                           ["link", "image"],
                           [{ color: ["red", "#785412"] }],
                           [{ background: ["red", "#785412"] }]                      
                      ],
                    }}
                  />  
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="featured_image">Featured Image:</label>
                  <input 
                    type="file" 
                    className="form-control" 
                    id="featured_image" 
                    accept="image/*" 
                    onChange={(e) => handleFileChange(e, setFeaturedImage)} 
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="thumbnail_image">Thumbnail Image:</label>
                  <input 
                    type="file" 
                    className="form-control" 
                    id="thumbnail_image" 
                    accept="image/*" 
                    onChange={(e) => handleFileChange(e, setThumbnailImage)} 
                  />
                </div>
                <div className='d-grid col-2 mx-auto'>
                <button type="submit" className="btn ls-btn  main-btn btn-lg" disabled={isSubmitting}>
                  {isSubmitting ? <FaSpinner className="spinner" /> : 'Submit'}
                </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogForm;
